module.exports = __webpack_public_path__ + "static/media/budget.f82954de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/budget.png
// module id = 94
// module chunks = 0